<template>
  <div>
    <div class="container">
      <LinkButton
        v-bind="{routeName: 'Units'}">
        Back to Rosters
      </LinkButton>
    </div>
    <!--<router-view name="subcontent"></router-view>-->
    <div
      class="typed-on-paper"
      v-if="data_loaded"
    >
      <h1 style="font-size: larger" class="text-align-center">ROSTERS</h1>

      <p class="text-align-left">
        Use the dropdown to either display the current roster of {{ this.baseName }}, or the roster of {{ this.baseName }}
      during a particular campaign. Only campaigns that {{ this.baseName }} took part in are available. The list for the current
      roster is divided into two lists, one for currently active members and one for members on leave (R&R). The campaign
      specific rosters show the members and any transfer- or membership status events that happened during the campaign.</p>
      <p>Select any of the displayed members in the roster to navigate to the members profile page for more detailed information.</p>

      <Roster
        v-bind:unit_id="this.unit_id"
        v-bind:campaign_id="this.campaign_to_show"
      >
      </Roster>
      <br>
      <select style="float: right" v-model="campaign_to_show">
        <option v-bind:value="0">Current roster</option>
        <option
          v-for="campaign in participated_campaigns"
          v-bind:value="campaign.campaign_id"
        >{{campaign.campaign_name}} - {{ campaign.base_unit_name }} flew as {{ campaign.hist_unit_name }}</option>
      </select>
      <br>
    </div>

  </div>

</template>

<script>
import { mapState, mapGetters } from "vuex"
import LinkButton from "../basic_comp/LinkButton"
import Roster from "./UnitRoster"

export default {
  name: "BaseUnit",
  components: {
    LinkButton,
    Roster
  },
  mounted () {

    this.updateUnitID(this.$route.params.unit_id);
  },
  beforeRouteUpdate (to, from, next) {
    // called when the route that renders this component has changed,
    // but this component is reused in the new route.
    // For example, for a route with dynamic params `/foo/:id`, when we
    // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // will be reused, and this hook will be called when that happens.
    // has access to `this` component instance.
    this.updateUnitID(to.params.unit_id);
    next();
  },
  data() {

    return {

      unit_id: 0,
      campaign_to_show: 0,
      data_loaded: false,

    }
  },
  computed: {

    baseName: function () {

      let unit_Array = this.filterByKey("campaign_units", "base_unit_id", this.unit_id);
      if(unit_Array.length > 0){
        return unit_Array[0].base_unit_name;
      } else {
        return "";
      }
    },

    histName: function () {

      let unit_Array = this.filterByKeys("campaign_units",
        {
          base_unit_id: this.unit_id,
          campaign_id: this.campaign_to_show

        }
      );
      if(unit_Array.length > 0){
        return unit_Array[0].hist_unit_name;
      } else {
        return "";
      }
    },

    participated_campaigns: function () {

      let return_array =  this.filterByKey("campaign_units", "base_unit_id", this.unit_id);
      return_array.sort(function(a,b){
        return b.campaign_id - a.campaign_id;
      })
      return return_array;
    },

    ...mapState('unitInfo', {

    }),

    ...mapGetters("unitInfo", [
      "findByKey",
      "filterByKey",
      "filterByKeys"
    ])

  },
  methods: {
    updateUnitID: async function (id) {


      this.unit_id = id;
      if(id > 0){

        await this.$store.dispatch('unitInfo/loadUnitInfo',
          {
            caller: this.$options.name,
            base_unit_id: id

          }
        ).then(response => {


          this.data_loaded = true;
        }).catch(error => {
            console.log(error.message);
          });

      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/unit/BaseUnit.vue